<!--
// FOR VNEXT-1726
// THIS FIELD CAN NO LONGER BE SELECTED IN THE FORM BUILDER
// Existing uses of it remain and function, you just can't create a new one in Forms Templates anymore
// FLEX FIELDS ARE NOW TO BE USED FOR ALL MULTI-SELECT FUNCTIONALITY
-->
<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>


<ng-template #multiDropDown>
    @if (this.DropDownReadyToDisplay) {
    @if (this.AutocompleteEnabled && !this.IsDesign) {
    <div>
        <app-autocomplete #multidropdownauto
                          [title]="this.DropDownOptionsTitle"
                          (selectedItems)="selectChange($event)"
                          (onBlur)="this.blurValidation()">
        </app-autocomplete>
    </div>
    } @else {
    <!-- If there are instructions, display label first, then instructions then field -->
    @if (this.HasInstructions) {
    @if (this.DisplayName) {
    <div class="{{this.Mode == 'design' ? 'design-mode-field-label' : 'field-label'}}">
        {{this.DisplayName}} @if (this.FormField.required) {
        <span style="color: #EF0000;">*</span>
        }
    </div>
    }
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    }
    <mat-form-field appearance="outline"
                    [floatLabel]="'always'"
                    subscriptSizing="dynamic"
                    class="full-width">
        <!-- If there are no instructions, display label integrated into the field -->
        @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
        <mat-label class="{{this.Mode =='design' ? 'design-mode-field-label' : 'field-label'}}">
            {{this.DisplayName}} @if (this.FormField.required) {
            <span style="color: #EF0000;">*</span>
            }
        </mat-label>
        }
        <span>
            @if (!this.SelectionsOpen && (this.Mode == 'instance' || this.Mode == 'preview')) {
            <button mat-raised-button
                    class="select-close-button"
                    color="primary"
                    (click)="openSelections()">
                Select
            </button>
            }
            @if (this.SelectionsOpen && (this.Mode == 'instance' || this.Mode == 'preview')) {
            <button mat-raised-button
                    class="select-close-button"
                    color="primary"
                    (click)="closeSelections()">
                Close
            </button>
            }
        </span>
        @if (this.Mode == 'instance' || this.Mode == 'preview') {
        <span class="selection-count">
            {{this.DropDownOptionsFormControl.value.length}} of {{this.DropDownOptions.length}} selected
        </span>
        }
        <mat-select #multiSelect
                    [formControl]="this.DropDownOptionsFormControl"
                    multiple
                    (blur)="multiSelectBlur()"
                    (opened)="multiSelectOpened()"
                    (closed)="multiSelectClosed()"
                    [disableOptionCentering]="true"
                    class="dropdown-select">
            <mat-select-trigger>
                <!--Intentionally leave empty so there are no values when an option is selected-->
            </mat-select-trigger>
            @for (dropDownOption of this.DropDownOptions; track dropDownOption) {
            <mat-option [disabled]="this.IsDesign"
                        title="{{dropDownOption}}"
                        [value]="dropDownOption">
                {{dropDownOption}}
            </mat-option>
            }
        </mat-select>
        <mat-chip-listbox [formControl]="this.DropDownOptionsFormControl">
            @for (selected of this.DropDownOptionsFormControl.value; track selected) {
            <mat-chip-option [removable]="true"
                             (removed)="onRemove(selected)"
                             class="mat-elevation-z2 regular-chip">
                {{selected}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip-option>
            }
            @if (this.ShowRemoveAll) {
            <mat-chip-option class="mat-elevation-z3 remove-all-chip" (click)="this.removeAllChips()" (keyup.enter)="this.removeAllChips()">
                Remove All
            </mat-chip-option>
            }
        </mat-chip-listbox>
    </mat-form-field>
    }
    <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
    }
</ng-template>

<div class="outer-div">
    <div class="flex-row-top-right">
        <div class="fill-remaining-space">
            <ng-template [ngTemplateOutlet]="multiDropDown"></ng-template>
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
    </div>
</div>
